<template>
  <div class="popup">
    <div class="inner">
      <div class="popup-header" :class="{ 'c-warning': typeIsWarning }">
        <button
          v-if="showHeaderNoticeIcon"
          type="button"
          class="header-notice-icon"
          :aria-label="$t('global.word.more_info')"
          :aria-expanded="showHeaderNotice ? 'true' : 'false'"
          @click="showHeaderNotice = !showHeaderNotice"
        >
          <img
            :src="getIcon('info-circle-warning.svg')"
            width="20"
            height="20"
            alt=""
          />
        </button>
        <div class="header-content">
          <h4>
            <slot name="header-text" />
          </h4>
          <span class="header-notice" v-if="showHeaderNotice">
            <slot name="header-notice" />
          </span>
        </div>

        <ELordIcon icon="close" stoke="100" @click="close" />
      </div>
      <div class="popup-body">
        <slot name="body" />
      </div>
      <div class="popup-footer" v-if="hasSlotFooter">
        <slot name="footer" />
      </div>
    </div>
    <div class="overlay" @click="close"></div>
  </div>
</template>

<script>
import ELordIcon from '@/components/utilities/ELordIcon';

export default {
  name: 'PopupBase',
  components: { ELordIcon },
  data() {
    return {
      showHeaderNotice: false,
    };
  },
  props: {
    showHeaderNoticeIcon: {
      type: Boolean,
      default: true,
    },
    typeIsWarning: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  computed: {
    hasSlotFooter() {
      return Boolean(this.$slots.footer);
    },
  },
};
</script>
